import {FETCHED_LANGUAGES} from './types';

export function fetchedLanguages(languages) {
    return {
        type: FETCHED_LANGUAGES,
        payload: languages
    }
}


// WEBPACK FOOTER //
// ./src/containers/languages/actions.js